import { inject } from "@angular/core";
import { CanMatchFn, Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";

import { CorityService } from "../services/cority.service";

import { OrgFacade } from "state/org.facade";

export const NonCorityGuard: CanMatchFn = (): Observable<true | UrlTree> => {
  const corityService = inject(CorityService);
  const orgFacade = inject(OrgFacade);
  const router = inject(Router);

  return orgFacade.org$.pipe(
    map((org) => {
      if (org && corityService.isCorityOrganization(org.externalClientApiKeyId)) {
        // Cority org, redirect to admin page
        return router.createUrlTree(["/admin"], {
          queryParamsHandling: "preserve",
        });
      } else {
        // Non-Cority org, allow access
        return true as const;
      }
    })
  );
};
